import React from 'react';
import Icon from '../../../components/AppIcon';
import DealStatusIndicator from '../../../components/ui/DealStatusIndicator';

const AcceptedOffers = ({ offers, currentLanguage }) => {
  const translations = {
    en: {
      title: 'Accepted Offers',
      noOffers: 'No accepted offers',
      fee: 'Fee',
      item: 'Item',
      route: 'Route'
    },
    ko: {
      title: '수락된 제안',
      noOffers: '수락된 제안이 없습니다',
      fee: '수수료',
      item: '물품',
      route: '경로'
    }
  };

  const t = translations?.[currentLanguage];

  const formatCurrency = (amount) => {
    return `${amount?.toLocaleString()}원`;
  };

  return (
    <div className="bg-card rounded-lg shadow-elevation-md overflow-hidden h-full flex flex-col">
      <div className="p-4 md:p-6 border-b border-border">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-success/10 rounded-lg flex items-center justify-center">
            <Icon name="Handshake" size={20} color="var(--color-success)" />
          </div>
          <h2 className="text-xl font-heading font-semibold text-foreground">
            {t?.title}
          </h2>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto">
        {offers?.length === 0 ? (
          <div className="p-6 text-center">
            <Icon name="Handshake" size={48} color="var(--color-muted)" className="mx-auto mb-3" />
            <p className="text-muted-foreground">{t?.noOffers}</p>
          </div>
        ) : (
          <div className="p-4 md:p-6 space-y-4">
            {offers?.map((offer) => (
              <div key={offer?.id} className="p-4 bg-muted/20 rounded-lg border border-border hover:border-success/50 transition-colors">
                {/* Status */}
                <div className="flex items-center justify-between mb-3">
                  <DealStatusIndicator status={offer?.status} currentLanguage={currentLanguage} />
                  <span className="text-lg font-semibold text-success">
                    {formatCurrency(offer?.request?.carrierFee || 0)}
                  </span>
                </div>

                {/* Item */}
                <div className="mb-3">
                  <div className="flex items-center gap-2 mb-1">
                    <Icon name="Package" size={14} color="var(--color-muted-foreground)" />
                    <span className="text-xs text-muted-foreground">{t?.item}</span>
                  </div>
                  <div className="text-sm font-medium text-foreground">
                    {offer?.request?.itemName}
                  </div>
                  <div className="text-xs text-muted-foreground mt-1">
                    {offer?.request?.category}
                  </div>
                </div>

                {/* Route */}
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <Icon name="MapPin" size={14} color="var(--color-muted-foreground)" />
                    <span className="text-xs text-muted-foreground">{t?.route}</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-foreground">
                    <span>{offer?.request?.originCountry}</span>
                    <Icon name="ArrowRight" size={14} color="var(--color-primary)" />
                    <span>{offer?.request?.destinationCountry}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AcceptedOffers;